import {
  normalizePatternData,
  renderPatternToDataUrl,
  type PatternRenderInput,
} from "@/utils/patternRenderer";
import { Image } from "antd";
import type { CSSProperties, ReactNode } from "react";
import { useMemo } from "react";

type PatternImageProps = {
  width?: number | null;
  height?: number | null;
  patternImageUrl?: string | null;
  patternGridJson?: unknown;
  patternLegendJson?: unknown;
  patternMetaJson?: unknown;
  alt: string;
  title?: string;
  className?: string;
  style?: CSSProperties;
  previewMask?: ReactNode;
};

export function getPatternImageUrl(
  params: PatternRenderInput & {
    fallbackUrl?: string | null;
  },
) {
  if (params.grid?.length) {
    return renderPatternToDataUrl(params);
  }
  return params.fallbackUrl || "";
}

export default function PatternImage({
  width,
  height,
  patternImageUrl,
  patternGridJson,
  patternLegendJson,
  patternMetaJson,
  alt,
  title,
  className,
  style,
  previewMask,
}: PatternImageProps) {
  const src = useMemo(() => {
    const pattern = normalizePatternData({
      width,
      height,
      patternGridJson,
      patternLegendJson,
      patternMetaJson,
    });
    if (!pattern) return patternImageUrl || "";
    return getPatternImageUrl({
      ...pattern,
      title,
      fallbackUrl: patternImageUrl,
    });
  }, [
    width,
    height,
    patternGridJson,
    patternLegendJson,
    patternMetaJson,
    patternImageUrl,
    title,
  ]);

  if (!src) return null;

  return (
    <Image
      src={src}
      alt={alt}
      className={className}
      style={style}
      preview={previewMask ? { mask: previewMask } : undefined}
    />
  );
}
